import * as React from 'react'

import { Alert, Box, Button } from '@factorialco/deprecated-design-system'
import { EnvironmentContext } from 'config/environment'
import copy from 'copy-to-clipboard'
import { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import InputText from 'modules/core/components/Inputs/Text'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'
import app from 'modules/core/store/models/app'

interface Props {
  onClose: () => void
}

const AppleCalendarModal = ({ onClose }: Props) => {
  const environment = React.useContext(EnvironmentContext)
  const copyText = (text: string) => (event: React.SyntheticEvent<Element, Event>) => {
    event.preventDefault()
    text && copy(text)
    app.setFlash({
      type: 'correct',
      message: i18n.t('common.copied'),
    })
  }

  const calendarToken = users.current.attributes.calendar_token
  const calendarUrl = `${environment.apiEndpoint}/icals?token=${calendarToken}`

  return (
    <Modal
      title={i18n.t('app_store_v2.integrations.apple_calendar.modal.title')}
      description={i18n.t('app_store_v2.integrations.apple_calendar.modal.description')}
      illustration="sync"
      onClose={onClose}
      onSubmit={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button type="primary" onClick={onClose}>
            {i18n.t('common.ok')}
          </Button>
        </>
      }
    >
      <Box gap="s24">
        <InputText
          readonly
          label={i18n.t('app_store_v2.integrations.apple_calendar.modal.url')}
          field={new Field(calendarUrl, 'string')}
        />
        <Button onClick={copyText(calendarUrl)} type="secondary">
          {i18n.t('app_store_v2.integrations.apple_calendar.modal.url_copy')}
        </Button>
        <Alert color="warning">
          {i18n.t('app_store_v2.integrations.apple_calendar.modal.note')}
        </Alert>
      </Box>
    </Modal>
  )
}

export default observer(AppleCalendarModal)
